import { useOpsUser } from './opsUser';
import { useTranslation } from 'react-i18next';
import styles from './PhoneBanner.module.css';

/**
 * Header banner when the signed-in ops user's work phone is missing/invalid —
 * shippers and drivers would otherwise fall back to the support number.
 */
export function PhoneBanner() {
  const { t } = useTranslation();
  const { opsUser } = useOpsUser();
  if (!opsUser || opsUser.phoneValid !== false) return null;
  return (
    <div className={styles.banner} role="status">
      <span className={styles.icon} aria-hidden="true">
        !
      </span>
      {t('ownership.phoneBanner.message')}
    </div>
  );
}
